// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "" + chunkId + "." + {"638":"d3e825feeaa6d51d9cee","776":"2b9e2940c4dba4cd47b8"}[chunkId] + ".chunk.css";
};